import { DeleteInspectionOutDto, DeleteInspectionInDto } from '../../../types/inspection.dto'

export const DELETE_INSPECTION = 'DELETE_INSPECTION'
export const DELETE_INSPECTION_SUCCESS = 'DELETE_INSPECTION_SUCCESS'
export const DELETE_INSPECTION_ERROR = 'DELETE_INSPECTION_ERROR'
export const RESET_DELETE_INSPECTION = 'RESET_DELETE_INSPECTION'

export interface DeleteInspection {
  type: typeof DELETE_INSPECTION
  payload: DeleteInspectionOutDto
}

export interface DeleteInspectionSuccess {
  type: typeof DELETE_INSPECTION_SUCCESS
  payload: DeleteInspectionInDto
}

export interface DeleteInspectionError {
  type: typeof DELETE_INSPECTION_ERROR
  payload: string | boolean
}

export interface ResetDeleteInspection {
  type: typeof RESET_DELETE_INSPECTION
  payload: null
}

export interface State {
  data: DeleteInspectionInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteInspection | DeleteInspectionSuccess | DeleteInspectionError | ResetDeleteInspection
